import { graphqlClient } from "../../../client";
import getResizeImageQueryDocument from "./getResizeImageQuery.graphql";
import type { Query, QueryResizeImageArgs, ResizeImageResultType } from "@/core/api/graphql/types";

export async function getResizeImage(payload: QueryResizeImageArgs): Promise<ResizeImageResultType> {
  const { data } = await graphqlClient.query<Required<Pick<Query, "resizeImage">>, QueryResizeImageArgs>({
    query: getResizeImageQueryDocument,
    variables: {
      ...payload,
    },
  });

  return data.resizeImage;
}
